// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
var context = React.createContext(undefined);
var provider = context.Provider;
function EditorLayerItem$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
EditorLayerItem$Provider.displayName = "EditorLayerItem.Provider";
var Provider = {
  provider: provider,
  make: EditorLayerItem$Provider
};
function use(param) {
  return React.useContext(context);
}
function EditorLayerItem$Internal(Props) {
  var tabIndex = Props.tabIndex;
  var kind = Props.kind;
  var role = Props.role;
  var data = Props.data;
  var ariaLabel = Props.ariaLabel;
  var fwdRef = Props.fwdRef;
  var canInspectChildrenOpt = Props.canInspectChildren;
  var className = Props.className;
  var style = Props.style;
  var children = Props.children;
  var id = Props.id;
  var category = Props.category;
  var nodeId = Props.nodeId;
  var canInspectChildren = canInspectChildrenOpt !== undefined ? canInspectChildrenOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = React.useState(function () {
    return [];
  });
  var setChildrenIds = match$1[1];
  var childrenIds = match$1[0];
  var match$2 = React.useState(function () {
    return Belt_Option.getWithDefault(id, Js_math.random_int(10000, 99999).toString());
  });
  var id$1 = match$2[0];
  var parentCtx = React.useContext(context);
  var theme = React.useMemo(function () {
    var path = category !== undefined ? Category$Showside.getCategoryPathById(config.categories, category.id) : [];
    var pathContainsConfigEmbed = Belt_Array.some(path, function (category) {
      var match = Category$Showside.ExternalConnection.getConnection(category);
      if (match !== undefined && !(typeof match === "number" || match.TAG !== /* ConfigEmbed */1)) {
        return true;
      } else {
        return false;
      }
    });
    if (pathContainsConfigEmbed) {
      return "purple";
    }
  }, [category]);
  var theme$1 = Belt_Option.getWithDefault(Belt_Option.orElse(theme, Belt_Option.map(parentCtx, function (ctx) {
    return ctx.theme;
  })), "blue");
  var ownContextValue = Belt_Option.map(kind, function (kind) {
    return {
      id: id$1,
      canInspect: canInspectChildren,
      kind: kind,
      theme: theme$1,
      childrenIds: childrenIds,
      setChildrenIds: setChildrenIds
    };
  });
  React.useEffect(function () {
    Belt_Option.forEach(parentCtx, function (param) {
      Curry._1(param.setChildrenIds, function (ids) {
        return Belt_Array.concat(ids, [id$1]);
      });
    });
    return function (param) {
      Belt_Option.forEach(parentCtx, function (param) {
        Curry._1(param.setChildrenIds, function (ids) {
          return Belt_Array.keep(ids, function (id) {
            return id !== id;
          });
        });
      });
    };
  }, [id$1]);
  var canInspect = Belt_Option.mapWithDefault(parentCtx, true, function (contextValue) {
    return contextValue.canInspect;
  });
  return Belt_Option.mapWithDefault(Belt_Option.keep(kind, function (param) {
    return canInspect;
  }), children, function (kind) {
    var tmp = {
      className: Cn.make(Belt_Array.keepMap(["sn-inspectable-widget", className], function (a) {
        return a;
      })),
      id: id$1
    };
    if (fwdRef !== undefined) {
      tmp.ref = Caml_option.valFromOption(fwdRef);
    }
    if (ariaLabel !== undefined) {
      tmp["aria-label"] = Caml_option.valFromOption(ariaLabel);
    }
    if (role !== undefined) {
      tmp.role = Caml_option.valFromOption(role);
    }
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    if (tabIndex !== undefined) {
      tmp.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    if (data !== undefined) {
      tmp.data = Caml_option.valFromOption(data);
    }
    return React.createElement(EditorLayerItem$Provider, {
      value: ownContextValue,
      children: React.createElement(Spread$Showside.make, {
        props: {
          "data-id": id$1,
          "data-kind": kind,
          "data-node-id": nodeId,
          "data-parent-id": Belt_Option.map(parentCtx, function (contextValue) {
            return contextValue.id;
          }),
          "data-children-ids": childrenIds.join(","),
          "data-siblings-ids": Belt_Option.map(parentCtx, function (contextValue) {
            return contextValue.childrenIds.join(",");
          }),
          "data-theme": theme$1
        },
        children: React.createElement("div", tmp, children)
      })
    });
  });
}
EditorLayerItem$Internal.displayName = "EditorLayerItem.Internal";
var Internal = {
  make: EditorLayerItem$Internal
};
function EditorLayerItem(Props) {
  var tabIndex = Props.tabIndex;
  var kind = Props.kind;
  var id = Props.id;
  var nodeId = Props.nodeId;
  var data = Props.data;
  var role = Props.role;
  var ariaLabel = Props.ariaLabel;
  var fwdRef = Props.fwdRef;
  var canInspectChildrenOpt = Props.canInspectChildren;
  var className = Props.className;
  var style = Props.style;
  var category = Props.category;
  var childrenOpt = Props.children;
  var canInspectChildren = canInspectChildrenOpt !== undefined ? canInspectChildrenOpt : true;
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var match = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match.previewMode;
  if (previewMode === 0) {
    var tmp = {
      canInspectChildren: canInspectChildren,
      children: children
    };
    if (tabIndex !== undefined) {
      tmp.tabIndex = tabIndex;
    }
    if (kind !== undefined) {
      tmp.kind = Caml_option.valFromOption(kind);
    }
    if (role !== undefined) {
      tmp.role = Caml_option.valFromOption(role);
    }
    var tmp$1 = Belt_Option.orElse(data, id);
    if (tmp$1 !== undefined) {
      tmp.data = Caml_option.valFromOption(tmp$1);
    }
    if (ariaLabel !== undefined) {
      tmp.ariaLabel = Caml_option.valFromOption(ariaLabel);
    }
    if (fwdRef !== undefined) {
      tmp.fwdRef = Caml_option.valFromOption(fwdRef);
    }
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    if (id !== undefined) {
      tmp.id = Caml_option.valFromOption(id);
    }
    if (category !== undefined) {
      tmp.category = Caml_option.valFromOption(category);
    }
    if (nodeId !== undefined) {
      tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    return React.createElement(EditorLayerItem$Internal, tmp);
  }
  var tmp$2 = {};
  if (fwdRef !== undefined) {
    tmp$2.ref = Caml_option.valFromOption(fwdRef);
  }
  if (ariaLabel !== undefined) {
    tmp$2["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (className !== undefined) {
    tmp$2.className = Caml_option.valFromOption(className);
  }
  if (id !== undefined) {
    tmp$2.id = Caml_option.valFromOption(id);
  }
  if (role !== undefined) {
    tmp$2.role = Caml_option.valFromOption(role);
  }
  if (style !== undefined) {
    tmp$2.style = Caml_option.valFromOption(style);
  }
  if (tabIndex !== undefined) {
    tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  var tmp$3 = Belt_Option.orElse(data, id);
  if (tmp$3 !== undefined) {
    tmp$2.data = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement("div", tmp$2, children);
}
EditorLayerItem.displayName = "EditorLayerItem";
var make = EditorLayerItem;
export { context, Provider, use, Internal, make };
/* context Not a pure module */